// API bases for calls that don't go through the shared axios instances (api.js, careiqapi.js,
// blinkscribeapi.js, dallasapi.js). Every value falls back to the prod URL, so prod builds are
// unchanged; dev builds (devcare) set the REACT_APP_* variables to point at their own gateways.
export const V1_BASE_URL = process.env.REACT_APP_BASE_URL || "https://api.prd.brainymed.com/ag";
export const V2_BASE_URL = process.env.REACT_APP_API_V2_BASE || "https://api.prd.brainymed.com/v2/ag";
export const BS_BASE = process.env.REACT_APP_API_BS_BASE || "https://api.prd.brainymed.com/bs";
export const DALLAS_BASE = process.env.REACT_APP_API_DALLAS_BASE || "https://api.prd.brainymed.com/dallas";
export const UTILITY_BASE = process.env.REACT_APP_API_UTILITY_BASE || "https://api.prd.brainymed.com/utility";
export const ONBOARDING_BASE = process.env.REACT_APP_ONBOARDING_BASE || "https://api.prd.brainymed.com/onboarding";

// BlinkScribe websocket base. A relative value (e.g. "/v2/bs") resolves against the page's own host.
export function bsWsBase() {
  const b = process.env.REACT_APP_API_BS_WS_BASE || "wss://api.prd.brainymed.com/v2/bs";
  if (b.startsWith("/")) return `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}${b}`;
  return b;
}
